import React from 'react'
import styled from 'styled-components'
import Scene from './components/Scene'

const App = () => {
	return (
		<Wrapper>
			<Title>
				<p>Exploration</p>
				<h1>Physical Affordances</h1>
			</Title>
			<Scene />
			<Footer>
				Exploration by{' '}
				<a href="https://www.alexwidua.com/">Alexander Widua</a> as part
				of <a href="http://uid.umu.se/en/">UID</a>'s 'Experience
				Prototyping' course.
			</Footer>
		</Wrapper>
	)
}

const Wrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100vh;
	background: #eee;
`

const Title = styled.div`
	position: absolute;
	top: 1.5rem;
	left: 1.5rem;
	z-index: 100;
	color: #fff;

	& p {
		margin-bottom: 0.5rem;
		font-family: var(--mono-font);
		font-size: 0.75rem;
	}
	& h1 {
		font-weight: 600;
		font-size: 1.5rem;
		letter-spacing: -0.01em;
	}

	@media (min-width: 1024px) {
		top: 3rem;
		left: 3rem;
		& p {
			margin-bottom: 0.75rem;
			font-size: 1rem;
		}

		& h1 {
			font-weight: 700;
			font-size: 2rem;
			letter-spacing: -0.03em;
		}
	}
`

const Footer = styled.footer`
	position: absolute;
	bottom: 2rem;
	left: 50%;
	transform: translateX(-50%);
	z-index: 0;
	text-align: center;
	width: 100%;
	line-height: 1.5;
	font-size: 0.75rem;
	font-family: var(--mono-font);
`

export default App
